import React from "react";
import i18n from "i18next";
import { emptyScenario } from "./schema";
import ScenarioPlayer from "./components/ScenarioPlayer";
import ScenarioEditor from "./components/ScenarioEditor";

/* eslint-disable react/prop-types */

export function InteractivePlugin(base) {
  return {
    getConfig: function () {
      return {
        name: "InteractivePlugin",
        displayName: i18n.t("InteractivePlugin.display_name", { defaultValue: "Interactive" }),
        category: "evaluation",
        icon: "flash_on",
        flavor: "react",
        initialWidth: "100%",
        initialHeight: "100%",
        initialWidthSlide: "100%",
        initialHeightSlide: "100%",
        allowFloatingBox: true,
        notResizable: true,
        fullScreenOverlay: true,
        initialState: { scenario: emptyScenario() },
        needsConfigModal: false,
        needsTextEdition: false,
        isRich: false,
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            scenario: {
              __name: i18n.t("InteractivePlugin.scenario", { defaultValue: "Senaryo" }),
              icon: "account_tree",
              buttons: {},
            },
          },
        },
      };
    },
    getRenderTemplate: function (state, props) {
      const safeProps = props || {};
      const isVisor = !!safeProps.visor;
      const scenario = (state && state.scenario) || null;
      const pluginBoxId = safeProps.pluginBoxId || safeProps.id || null;

      if (isVisor) {
        // The editor needs the editor store; a box without a scenario has nothing to play.
        return scenario ? <ScenarioPlayer scenario={scenario} pluginBoxId={pluginBoxId} /> : null;
      }

      return <ScenarioEditor pluginBoxId={pluginBoxId} />;
    },
  };
}
